import { LogErrors } from './../../LogErrors'
import { 
    GetInstructors as DLGetInstructors,
    GetCoursesByGroup as DLGetCoursesByGroup,
    GetEvaluationsByCourse as DLGetEvaluationsByCourse,
    ReportExportAll as DLReportExportAll,
    ReportAttemptsGrouped as DLReportAttemptsGrouped,
    ReportAttemptDetail as DLReportAttemptDetail
} from './../../DL/Leader/Results'


/**
 * Función centralizada para obtener los datos de la sesión necesarios para los reportes.
 */
const getSessionBaseData = () => {
    if (!sessionStorage.getItem('userData')) return null
    
    const userData = JSON.parse(sessionStorage.getItem('userData'))
    const token = userData?.token
    const idCenter = userData?.navigation?.center?.id
    const centerName = userData?.navigation?.center?.name || userData?.centerName || "Centro"
    const idUserRol = 3 // Rol estático 3 para Líderes según documentación de API
    
    if (!token || !idCenter) return null
    return { token, idCenter, centerName, idUserRol }
}

const GetInstructorsList = async () => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión inválida.' }

        const response = await DLGetInstructors(session.idCenter, session.idUserRol, session.token)
        if (response.success) {
            // El backend devuelve { instructors: [...] }. Lo extraemos para comodidad del front.
            return { success: true, data: response.data.instructors || [] }
        }
        return response
    } catch (error) {
        await LogErrors('GetInstructorsList - BL Results', error)
        return { success: false, message: 'Error interno al cargar instructores.' }
    }
}

const GetCoursesForSelectedGroup = async (idInstructor, idGroup) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión inválida.' }

        return await DLGetCoursesByGroup(session.idCenter, session.idUserRol, idInstructor, idGroup, session.token)
    } catch (error) {
        await LogErrors('GetCoursesForSelectedGroup - BL Results', error)
        return { success: false, message: 'Error interno al cargar cursos.' }
    }
}

const GetEvaluationsForSelectedCourse = async (idCourse) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión inválida.' }

        return await DLGetEvaluationsByCourse(session.idCenter, session.idUserRol, idCourse, session.token)
    } catch (error) {
        await LogErrors('GetEvaluationsForSelectedCourse - BL Results', error)
        return { success: false, message: 'Error interno al cargar evaluaciones.' }
    }
}

const GetAllResultsForInstructor = async (idInstructor) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión inválida.' }

        return await DLReportExportAll(session.idCenter, session.idUserRol, idInstructor, session.token)
    } catch (error) {
        await LogErrors('GetAllResultsForInstructor - BL Results', error)
        return { success: false, message: 'Error interno al generar reporte completo.' }
    }
}

const GetFilteredTableResults = async ({ idInstructor, idGroup, idCourse, idBlock, pageNumber, pageSize }) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión inválida.' }

        const payload = {
            IdUserRol: session.idUserRol,
            IdInstructor: idInstructor,
            idCenter: session.idCenter,
            groupId: idGroup,
            courseId: idCourse,
            blockId: idBlock,
            page: pageNumber,
            pageSize: pageSize
        }

        return await DLReportAttemptsGrouped(payload, session.token)
    } catch (error) {
        await LogErrors('GetFilteredTableResults - BL Results', error)
        return { success: false, message: 'Error interno al obtener resultados.' }
    }
}

const GetDetailedSingleReport = async (rowDetails) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión inválida.' }

        const payload = {
            IdUserRol: session.idUserRol,
            attemptNumber: rowDetails.attemptNumber || 1,
            centerName: session.centerName,
            courseId: rowDetails.courseId,
            groupId: rowDetails.groupId,
            groupName: rowDetails.groupName,
            idCenter: session.idCenter,
            studentId: rowDetails.studentId,
            token: rowDetails.evaluationToken
        }

        return await DLReportAttemptDetail(payload, session.token)
    } catch (error) {
        await LogErrors('GetDetailedSingleReport - BL Results', error)
        return { success: false, message: 'Error interno al generar reporte individual.' }
    }
}

export { GetInstructorsList, GetCoursesForSelectedGroup, GetEvaluationsForSelectedCourse, GetAllResultsForInstructor, GetFilteredTableResults, GetDetailedSingleReport };